<script>
import { required, email } from "@vuelidate/validators";
import useVuelidate from '@vuelidate/core'
import { mapGetters, mapActions } from 'vuex';

export default {
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      email: null,
      result: 0
    };
  },
  validations() {
    const rules = {
      email: { required, email }
    };
    return rules;
  },
  computed :{
    ...mapGetters('auth', {
      processing: 'processing'
    }),
  },
  methods: {
    ...mapActions('auth', {
      resetPassword: 'resetPassword'
    }),
    async submit () {
      const isValid = await this.v$.$validate();
      if(isValid) {
        const {  email } = this;
        this.resetPassword({ email })
          .then(() => {
            this.result = 2;
          })
          .catch(() => {
            this.result = 1;
          });
      }
    }
  }
}
</script>

<template>
 <div class="auth-page">
      <div class="container-fluid p-0">
          <div class="row g-0 align-items-center">
              <div class="col-xxl-4 col-lg-4 col-md-6">
                  <div class="row justify-content-center g-0">
                      <div class="col-xl-9">
                          <div class="p-4">
                              <div class="card mb-0">
                                  <div class="card-body">
                                      <div class="auth-full-page-content rounded d-flex p-3 my-2">
                                          <div class="w-100">
                                              <form class="d-flex flex-column h-100">
                                                
                                                  <div class="mb-4 mb-md-5">
                                                      <router-link to="/" class="d-block auth-logo">
                                                          <img src="@/assets/images/logo-dark.png" alt="" height="22" class="auth-logo-dark me-start">
                                                          <img src="@/assets/images/logo-light.png" alt="" height="22" class="auth-logo-light me-start">
                                                      </router-link>
                                                  </div>
                                                  <div class="auth-content my-auto" v-if="result === 2">
                                                    <div class="text-center">
                                                      <h5 class="mb-0">Reset Password</h5>
                                                      <p class="text-muted mt-2">Reset Password with VostokSOS CRM.</p>
                                                    </div>
                                                    <div class="alert alert-success text-center my-4 font-size-12" role="alert">
                                                        <p>
                                                          Please check your email.
                                                        </p>
                                                        <p>
                                                          If you do not see the email in a few minutes, check your “junk mail” folder or “spam” folder.
                                                        </p>
                                                        <p>
                                                          If you still don’t receive an email, then write to contact@VostokSOS_CRM.com explaining the problem. We will do our best to answer your request as soon as possible.
                                                        </p>
                                                    </div>
                                                  </div>
                                                  <div class="auth-content my-auto" v-if="result === 1">
                                                    <div class="text-center">
                                                      <h5 class="mb-0">Reset Password</h5>
                                                      <p class="text-muted mt-2">Reset Password with VostokSOS CRM.</p>
                                                    </div>
                                                    <div class="alert alert-warning text-center my-4 font-size-12" role="alert">
                                                        <p>
                                                         An error has occured. Try again later.
                                                        </p>
                                                    </div>
                                                  </div>
                                                  <div class="auth-content my-auto" v-if="result === 0">
                                                      <div class="text-center">
                                                          <h5 class="mb-0">Reset Password</h5>
                                                          <p class="text-muted mt-2">Reset Password with VostokSOS CRM.</p>
                                                      </div>
                                                      <div class="alert alert-info text-center my-4 font-size-12" role="alert">
                                                          Enter your Email and instructions will be sent to you!
                                                      </div>
                                                      <form class="mt-4 pt-2">
                                                          <div class="mb-4">
                                                              <label for="input-email">Email</label>
                                                              <input type="email" class="form-control" id="input-email" placeholder="Enter Email" v-model="email" :class="{ 'is-invalid': v$.email.$error }">
                                                              <div class="invalid-feedback">
                                                                  Please Enter Email
                                                              </div> 
                                                          </div>
                                                          <div class="mb-3">
                                                            <button class="btn btn-primary w-100 waves-effect waves-light" type="button" @click="submit" :disabled="processing">
                                                              <i class="fa fa-spin fa-spinner me-2" v-if="processing"></i>
                                                              Reset
                                                            </button>
                                                          </div>
                                                      </form>
                  
                                                      <div class="mt-4 pt-3 text-center">
                                                          <p class="text-muted mb-0">Remember It ?  <router-link to="/login"
                                                              class="text-primary fw-semibold"> Login </router-link> </p>
                                                      </div>
                                                  </div>
                                                  <div class="mt-4 text-center">
                                                      <p class="mb-0">© {{new Date().getFullYear()}} VostokSOS CRM. </p>
                                                  </div>
                                              </form>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <!-- end auth full page content -->
              </div>
              <!-- end col -->
              <div class="col-xxl-8 col-lg-8 col-md-6">
                  <div class="auth-bg bg-white py-md-5 p-4 d-flex">
                      <div class="bg-overlay bg-white"></div>
                      <!-- end bubble effect -->
                      <div class="row justify-content-center align-items-center">
                          <div class="col-xl-8">
                              <div class="mt-4">
                                  <img src="@/assets/images/login-img.png" class="img-fluid" alt="">
                              </div>
                              
                          </div>
                      </div>
                  </div>
              </div>
              <!-- end col -->
          </div>
          <!-- end row -->
      </div>
      <!-- end container fluid -->
  </div>
</template>